import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Menu, X } from 'lucide-react';
import logo from '../../Images/logo4.png';
import '../index.css';

const navItemsByPath = {
	'/signup': [
		{ label: 'Sign in', to: '/signin', variant: 'button' },
		{ label: 'Pricing', to: '/pricing', variant: 'button' },
	],
	'/signin': [
		{ label: 'Pricing', to: '/pricing', variant: 'button' },
		{ label: 'Sign up', to: '/signup', variant: 'cta' },
	],
	'/pricing': [
		{ label: 'Sign up', to: '/signup', variant: 'cta' },
		{ label: 'Sign in', to: '/signin', variant: 'button' },
	],
	'/about-us': [
		{ label: 'Pricing', to: '/pricing', variant: 'button' },
		{ label: 'Sign in', to: '/signin', variant: 'button' },
		{ label: 'Start for free', to: '/signup', variant: 'cta', icon: true },
	],
	'/contact-us': [
		{ label: 'Pricing', to: '/pricing', variant: 'button' },
		{ label: 'Sign in', to: '/signin', variant: 'button' },
		{ label: 'Start for free', to: '/signup', variant: 'cta', icon: true },
	],
	default: [
		{ label: 'Features', href: '#features', variant: 'button' },
		{ label: 'Pricing', to: '/pricing', variant: 'button' },
		{ label: 'Sign in', to: '/signin', variant: 'button' },
		{ label: 'Start for free', to: '/signup', variant: 'cta', icon: true },
	],
};

function MainNavbar() {
	const [isOpen, setIsOpen] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	const { pathname } = useLocation();
	const links = navItemsByPath[pathname] || navItemsByPath.default;

	useEffect(() => {
		const onScroll = () => setIsScrolled(window.scrollY > 24);
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	const closeMenu = () => setIsOpen(false);

	return (
		<header className={`landing-nav ${isScrolled ? 'is-scrolled' : ''}`}>
			<Link className='landing-nav__brand' to='/landing' onClick={closeMenu}>
				<img
					className='landing-nav__logo'
					src={logo}
					alt='Wiciny Business logo'
				/>
				<span>Wiciny Business</span>
			</Link>

			<nav
				className={`landing-nav__links ${isOpen ? 'is-open' : ''}`}
				aria-label='Landing navigation'>
				{links.map((link) => {
					const className =
						link.variant === 'cta' ? 'landing-nav__cta' : 'landing-nav__button';
					const content = (
						<>
							{link.label}
							{link.icon && <ArrowRight size={16} aria-hidden='true' />}
						</>
					);

					return link.to ? (
						<Link className={className} key={link.to} to={link.to} onClick={closeMenu}>
							{content}
						</Link>
					) : (
						<a
							className={className}
							key={link.href}
							href={link.href}
							onClick={closeMenu}>
							{content}
						</a>
					);
				})}
			</nav>

			<button
				className='landing-nav__toggle'
				type='button'
				aria-label={isOpen ? 'Close navigation' : 'Open navigation'}
				aria-expanded={isOpen}
				onClick={() => setIsOpen((current) => !current)}>
				{isOpen ? (
					<X size={22} aria-hidden='true' />
				) : (
					<Menu size={22} aria-hidden='true' />
				)}
			</button>
		</header>
	);
}

export default MainNavbar;
